<template>
  <div class="level__title-wrapper">
    <p class="level__title">
      <span>
        {{ title }}
      </span>
      <label v-if="hasAccess" class="level__title__label">
        <span
          v-if="learningArea"
          class="level__title__label-learningArea"
          :style="{
            '--area-color': getLearningAreaSnipeColor(learningArea),
          }"
        >
          {{ learningArea }}
        </span>
        <span
          v-for="(detail, index) in details"
          :key="index"
          class="level__title__label-detail"
          :class="textClass ? `level__title__label-detail--${textClass}` : ''"
          v-html="detail"
        >
        </span>
      </label>
    </p>
  </div>
</template>

<script>
import { getLearningAreaSnipeColor } from '@/helpers'

export default {
  name: 'LevelTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: false,
      default: () => [],
    },
    learningArea: {
      type: String,
      required: false,
    },
    textClass: {
      type: String,
      required: false,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getLearningAreaSnipeColor,
  },
}
</script>
